<template>
  <div id="assist_poster" class="animated fadeIn" @click.self="close" ref="main">
    <div v-if="!poster" class="empty">
      <InlineLoading />
    </div>
    <div ref="poster" v-else class="container animated slideInUp">
      <img :src="poster" />
      <h1>
        <i class="anyteachicon anyteach-arrow-up" />
        <span>长按上方图片保存</span>
      </h1>
    </div>
  </div>
</template>

<script>
import Toast from "mand-mobile/lib-vw/toast"
export default {
  name: "AssistPoster",
  props: ["selectedRule"],
  data() {
    return {
      poster: null,
    }
  },
  methods: {
    close() {
      this.$refs.main && this.$refs.main.classList.add("fadeOut")
      this.$refs.poster && this.$refs.poster.classList.add("slideOutDown")
      setTimeout(() => {
        this.$emit("close")
      }, 500)
    },
    async getPoster() {
      try {
        this.poster = await this.$api.assist.POSTER(this.selectedRule.id)
        Toast.hide()
      } catch (err) {
        const url = `/assist?ar_id=${this.selectedRule.id}&user_id=${this.$store.state.user.user_id}&showShare=1`
        this.$router.push(url)
        this.close()
      }
    },
  },
  created() {
    this.getPoster()
  },
}
</script>

<style lang="scss" scoped>
@import "../style.scss";

.animated {
  animation-delay: 0s !important;
  animation-duration: 0.5s !important;
}
#assist_poster {
  position: fixed;
  top: 0;
  left: 0;
  overflow: scroll;
  width: 100%;
  height: 100vh;
  z-index: 2;
  background: $blackBgd;
  display: flex;
  align-items: center;
  justify-content: center;
}

.empty {
  height: 80vh;
  background: none;
}
.empty,
.container {
  width: 70%;
}
.container {
  text-align: center;
  img {
    width: 100%;
    height: auto;
  }
  h1 {
    color: white;
    font-size: 0.9rem;
    padding: 5px 0 0 0;
    i {
      font-size: inherit;
      padding: 0 0 0 5px;
      animation: 1.2s ease-out infinite hover;
      -webkit-animation: 1.2s ease-out infinite hover;
      -moz-animation: 1.2s ease-out infinite hover;
    }
    @keyframes hover {
      50% {
        transform: translateY(-4px);
      }
    }
  }
}
</style>
